import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import PickingAllocErrorReportActions from '../../Stores/PickingAllocErrorReport/Actions';

const { Panel } = Collapse;

class PickingAllocErrorReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initPickingAllocError } = this.props;

    if (curSiteFlowId > 0) {
      initPickingAllocError();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initPickingAllocError } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initPickingAllocError();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'picking_allocation_error_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

PickingAllocErrorReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initPickingAllocError: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

PickingAllocErrorReportScreen.defaultProps = {
  intl: {},
  match: {},

  initPickingAllocError: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initPickingAllocError: () =>
    dispatch(PickingAllocErrorReportActions.pickingAllocErrorReportInitPickingAllocError())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(PickingAllocErrorReportScreen));
